import { Skeleton } from '@/core/tamagoshiTailwind/components/Skeleton/Skeleton';

export const DeliverySectionButtonSkeleton = () => (
  <Skeleton.Group
    className="flex min-h-[64px] flex-wrap gap-xs border-b
      border-foundation-primary bg-foundation-inverted py-m"
  >
    <Skeleton.Group className="flex flex-1 items-center gap-s">
      <Skeleton.Block width="35%" height="body1" />

      <Skeleton.Group className="flex flex-auto justify-end">
        <Skeleton.Block width={24} height={24} />
      </Skeleton.Group>
    </Skeleton.Group>

    <Skeleton.Group className="w-full">
      <Skeleton.Block height="20px" width="60%" />
    </Skeleton.Group>

    <Skeleton.Group className="w-full">
      <Skeleton.Block height="20px" width="40%" />
    </Skeleton.Group>
  </Skeleton.Group>
);

DeliverySectionButtonSkeleton.displayName = 'DeliverySectionButtonSkeleton';
